import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';

const rootSelector = (state: TAppState) => state[TABLE_REPORT_SLICE];

export const selectDownloadDocumentsReports = createSelector(
    rootSelector,
    ({reportDownloadDocuments}) => reportDownloadDocuments,
);

export const selectDocumentUploadInfo = createSelector(rootSelector,
    ({documentUploadInfo}) => documentUploadInfo);

export const selectModalReportDownloadDocument = createSelector(
    rootSelector,
    ({reportDownloadDocuments}) => reportDownloadDocuments?.modalReportDownloadDocument,
);
